var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0085 2.85303C13.4481 2.85929 13.8674 3.039 14.1751 3.35303L17.3418 6.51969C17.6558 6.82741 17.8355 7.24675 17.8418 7.68636V16.1864C17.8418 16.6284 17.6662 17.0523 17.3536 17.3649C17.0411 17.6774 16.6172 17.853 16.1751 17.853H4.50846C4.06644 17.853 3.64251 17.6774 3.32995 17.3649C3.01739 17.0523 2.8418 16.6284 2.8418 16.1864V4.51969C2.8418 4.07767 3.01739 3.65374 3.32995 3.34118C3.64251 3.02862 4.06644 2.85303 4.50846 2.85303H13.0085Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5086 17.853V12.0197C14.5086 11.7987 14.4208 11.5867 14.2645 11.4304C14.1083 11.2742 13.8963 11.1864 13.6753 11.1864H7.00863C6.78761 11.1864 6.57565 11.2742 6.41937 11.4304C6.26309 11.5867 6.17529 11.7987 6.17529 12.0197V17.853M6.17529 2.85303V6.18636C6.17529 6.40737 6.26309 6.61934 6.41937 6.77562C6.57565 6.9319 6.78761 7.01969 7.00863 7.01969H12.842",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.9a266dfa02351466b9f8e5b44821d320.svg";
export { ForwardRef as ReactComponent };